var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AppLayout from '@/Layouts/AppLayout';
import Tabs from '@/Jetstream/Tabs';
import { BuildingOfficeIcon, CalendarIcon, DocumentPlusIcon, DocumentTextIcon, UserIcon } from "@heroicons/react/24/outline";
import useTypedPage from "@/Hooks/useTypedPage";
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
export default function DashboardLayout(_a) {
    var team = _a.team, branch = _a.branch, title = _a.title, breadCrumb = _a.breadCrumb, pageTitle = _a.pageTitle, children = _a.children;
    console.log('DashboardLayout...');
    var current = window.location.href.replace(/\?.*/, '');
    var page = useTypedPage();
    var route = useRoute(Ziggy);
    return (_jsxs(AppLayout, __assign({ title: title, breadCrumb: breadCrumb, pageTitle: pageTitle }, { children: [_jsx(Tabs, { className: "mb-4", tabs: [
                    {
                        id: 'certificates-tab',
                        "name": 'Certificates',
                        "href": route('team.branch.certificate.index', { "team": team.id, "branch": branch.id }),
                        "icon": DocumentTextIcon,
                        "current": current.match(/certificate$/) || current.match(/certificate\/ehc$/) || current.match(/certificate\/ahc$/),
                        count: branch.certificates_count,
                    },
                    {
                        id: 'details-tab',
                        name: 'Details',
                        href: route('team.branch.show', { team: team.id, branch: branch.id }),
                        icon: BuildingOfficeIcon,
                        current: route('team.branch.show', { team: team.id, branch: branch.id }) == current,
                        count: branch.is_details_complete ? null : "!"
                    },
                    {
                        id: 'client-forms-tab',
                        name: 'Schedule',
                        href: route('team.branch.client-form.index', { team: team.id, branch: branch.id }),
                        icon: CalendarIcon,
                        "current": current.match(/client-form/),
                        count: branch.client_forms_upcoming_count,
                    },
                    {
                        id: 'clients-tab',
                        name: 'Clients',
                        href: route('team.branch.client.index', { team: team.id, branch: branch.id }),
                        icon: UserIcon,
                        current: route('team.branch.client.index', { team: team.id, branch: branch.id }) == current,
                        count: branch.clients_count,
                    },
                    {
                        id: 'vets-tab',
                        name: 'Vets',
                        href: route('team.branch.vet.index', { team: team.id, branch: branch.id }),
                        icon: UserIcon,
                        current: route('team.branch.vet.index', { team: team.id, branch: branch.id }) == current,
                        count: branch.vets_count,
                    },
                    {
                        id: 'certificate-numbers-tab',
                        name: 'Certificate numbers',
                        href: route('team.branch.certificate-number.index', { team: team.id, branch: branch.id }),
                        icon: DocumentPlusIcon,
                        current: route('team.branch.certificate-number.index', { team: team.id, branch: branch.id }) == current,
                        count: branch.certificate_numbers_count,
                    },
                ].filter(Boolean) }), children] })));
}
